import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const shortcuts = [
  { key: 'Up/Down Arrow', action: 'Navigate through files' },
  { key: 'Enter', action: 'Open selected file or folder' },
  { key: 'F2', action: 'Rename selected file or folder' },
  { key: 'Delete', action: 'Delete selected file or folder' },
  { key: 'Ctrl/Cmd + C', action: 'Copy selected file or folder' },
  { key: 'Ctrl/Cmd + V', action: 'Paste copied file or folder' },
  { key: 'Space', action: 'Select or deselect file or folder' },
  { key: 'Ctrl/Cmd + A', action: 'Select all files' },
];

interface ShortcutsHelpProps {
  open: boolean;
  onClose: () => void;
}

const ShortcutsHelp: React.FC<ShortcutsHelpProps> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Keyboard Shortcuts</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Here are some useful keyboard shortcuts for the file manager:
        </Typography>
        <ul>
          {shortcuts.map((shortcut, index) => (
            <li key={index}>
              <strong>{shortcut.key}</strong>: {shortcut.action}
            </li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShortcutsHelp;